// Small, pure helpers for showing pipeline results and the calendar horizon.
export const TZ = 'America/Chicago';
const DAY = 86400000;

export function formatWhen(iso, tz = TZ) {
  if (!iso) return '';
  const d = new Date(iso);
  const day = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short', month: 'short', day: 'numeric' }).format(d);
  const time = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour: 'numeric', minute: '2-digit' }).format(d);
  return `${day} · ${time}`;
}

export function formatDay(iso, tz = TZ) {
  if (!iso) return '';
  return new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short', month: 'short', day: 'numeric' }).format(new Date(iso));
}

// "today" / "tomorrow" / "11 days ahead", counted in whole days from now.
export function describeAhead(iso, now = Date.now()) {
  if (!iso) return '';
  const days = Math.max(0, Math.ceil((new Date(iso).getTime() - now) / DAY));
  if (days === 0) return 'today';
  if (days === 1) return 'tomorrow';
  return `${days} days ahead`;
}

// What the calendar header shows: how far ahead content is scheduled, and the next
// post per platform. posts: [{ platform, scheduledAt, status }] from /calendar/posts.
export function summarizeHorizon(posts = [], now = Date.now()) {
  const upcoming = posts
    .filter((p) => p && p.scheduledAt && ['scheduled', 'pending', 'queued'].includes(String(p.status || 'scheduled').toLowerCase()) && new Date(p.scheduledAt).getTime() >= now - 60 * 1000)
    .sort((a, b) => new Date(a.scheduledAt) - new Date(b.scheduledAt));
  if (!upcoming.length) return { count: 0, firstAt: null, lastAt: null, platforms: [] };
  const byPlatform = new Map();
  for (const p of upcoming) {
    const key = p.platform || 'unknown';
    const entry = byPlatform.get(key) || { platform: key, count: 0, nextAt: p.scheduledAt, lastAt: p.scheduledAt };
    entry.count += 1; entry.lastAt = p.scheduledAt;
    byPlatform.set(key, entry);
  }
  return {
    count: upcoming.length,
    firstAt: upcoming[0].scheduledAt,
    lastAt: upcoming[upcoming.length - 1].scheduledAt,
    platforms: [...byPlatform.values()].sort((a, b) => new Date(a.nextAt) - new Date(b.nextAt)),
  };
}
